import {Component, ElementRef, OnInit, Renderer2, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {environment} from '../../../../../environments/environment';
import {StorageService} from '../../../../_services/storage.service';
import {UserService} from '../../../../_services';
import {first} from 'rxjs/operators';
import {LoadingService} from '../../../../_services/loading.service';
import {ToastService} from '../../../../_services/toast.service';
import {Router, Routes} from '@angular/router';
import {DetectLocationComponent} from '../../../../components/detect-location/detect-location.component';
import {ModalController} from '@ionic/angular';
import {CreateAccountSuccessComponent} from './create-account-success.component';
import {CommonService} from '../../../../_services/common.service';

@Component({
  selector: 'app-why-user-account',
  templateUrl: './user-account.component.html',
  styleUrls: ['./user-account.component.scss']
})
export class UserAccountComponent implements OnInit {
  @ViewChild('header') header: any;
  userAccountForm: FormGroup;
  submitted = false;
  public project = {
    type: 'ic',
    logo: '/assets/img/logo/LOGO-IC.svg',
    name: 'INVISIBLECITY'
  };

  constructor(public element: ElementRef,
              public renderer: Renderer2,
              public authService: UserService,
              public spinner: LoadingService,
              public toast: ToastService,
              private modalController: ModalController,
              private router: Router,
              private commonService: CommonService,
              public storageService: StorageService) {

    this.userAccountForm = new FormGroup({
      language: new FormControl('', []),
      customLanguage: new FormControl('', []),
      identity: new FormControl('', []),
      customIdentity: new FormControl('', [Validators.maxLength(100)])
    });
  }

  ionViewWillEnter() {
    this.renderer.setStyle(this.header.el, 'webkitTransition', 'top 700ms');
  }

  async onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.userAccountForm.invalid) {
      return;
    }
    const userObj = await this.storageService.get(environment.userObj);
    const profileObj = {
      firstLanguageEnglish: this.userAccountForm.value.language,
      firstLanguageDescription: this.userAccountForm.value.customLanguage,
      culturalIdentity: this.userAccountForm.value.identity,
      culturalIdentityDescription: this.userAccountForm.value.customIdentity
    };
    Object.assign(userObj.profileObj, profileObj);
    this.spinner.show();
    this.authService.register(userObj)
      .pipe(first())
      .subscribe(
        (dataObj) => {
          this.spinner.hide();
          // this.googleAnalyticsService.eventEmitter('Auth', 'register', 'success', user.email);
          this.successSignUpModal();
        },
        (error) => {
          this.spinner.hide();
          // this.toast.error('Failed to create an create account please contact admin');
          this.toast.error(error.error.message);
          console.error('error is', error.error.message);
        });
  }

  async successSignUpModal() {
    const modal = await this.modalController.create({
      component: CreateAccountSuccessComponent,
      cssClass: 'pop-up-modal sm',
      showBackdrop: true,
      backdropDismiss: true,
    });
    modal.onDidDismiss()
      .then(() => {
        // [this.project.type, this.project.logo] = this.commonService.getProjectLogo(params.projectType);
        const projectType = localStorage.getItem('projectType');
        this.router.navigate(['./project/' + projectType]);
      });
    return await modal.present();
  }

  ngOnInit(): void {
    if (this.userAccountForm.get('language').value === '') {
      this.userAccountForm.get('language').patchValue('not_say');
      this.userAccountForm.get('identity').patchValue('not_say');
    }
  }
}
